export const ADD_CSR_SETTINGS = 'ADD_CSR_SETTINGS';
export const ADD_EDIT_DEDUCTION_SETTINGS = 'ADD_EDIT_DEDUCTION_SETTINGS';
export const ADD_EXPIRATION_DATE = 'ADD_EXPIRATION_DATE';
export const ADD_ITEM_ORDER = 'ADD_PURCHASE_ORDER'
export const ADD_INVENTORY_ITEMS = 'ADD_INVENTORY_ITEMS';
export const ADD_LOCATION_BLANK = 'ADD_LOCATION_BLANK';
export const ADD_ROLE = "ADD_ROLE";
export const ADD_UPDATE_CSR = 'ADD_CSR_ASSIGNMENTS';
export const ADD_WAGE = 'ADD_WAGE';
export const ALL_COMPANIES = 'ALL_COMPANIES';
export const ALL_USERS = 'ALL_USERS';
export const ANNUAL_BILLING_SETTINGS = 'ANNUAL_BILLING_SETTINGS';
export const APAR_REPORT = 'APAR_REPORT';
export const APAR_SETUP = 'APAR_SETUP';
export const AVAILABLE_ITEMS = 'AVAILABLE_ITEMS'
export const BANK_CONVERSION = 'BANK_CONVERSION';
export const CERTIFIED_PAYROLL_SETTINGS = 'CERTIFIED_PAYROLL_SETTINGS';
export const CHILD_COST_CENTERS = 'CHILD_COST_CENTERS';
export const CHILD_COST_CENTERS_MULTI = 'CHILD_COST_CENTERS_MULTI';
export const CLIENT_PERMISSIONS = 'CLIENT_PERMISSIONS';
export const CLOCKS_BILLING_ITEMS = 'CLOCKS_BILLING_ITEMS';
export const CLOCK_ITEM = 'CLOCK_ITEM';
export const CLOCKS_ITEMS = 'CLOCKS_ITEMS';
export const CLOCKS_SUMMARY = 'CLOCKS_SUMMARY';
export const COMPANY_EINS = "COMPANY_EINS";
export const COORDINATOR = 'COORDINATOR';
export const COST_CENTERS = 'COST_CENTERS';
export const COST_CENTER_JOBS = 'COST_CENTER_JOBS';
export const COST_CENTER_LEVELS = 'COST_CENTER_LEVELS';
export const COUNTERS = "COUNTERS";
export const COUNTY_WAGE = 'COUNTY_WAGE';
export const CSR_ASSIGNMENT_SETTINGS = 'CSR_ASSIGNMENT_SETTINGS';
export const CSRS = 'CSRS';
export const DEDUCTION_CODES = 'DEDUCTION_CODES';
export const DEDUCTION_COMPARISON_REPORT = "DEDUCTION_COMPARISON_REPORT";
export const DEDUCTION_SCHEDULES = 'DEDUCTION_SCHEDULES';
export const DEFAULT_EIN = "DEFAULT_EIN";
export const DELETE_CSR_ASSIGNMENTS = 'DELETE_CSR_ASSIGNMENTS';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const DELETE_WAGE = 'DELETE_WAGE';
export const DIRECT_DEPOSIT = 'DIRECT_DEPOSIT';
export const DISTRIBUTION_COMPARISON_REPORT = "DISTRIBUTION_COMPARISON_REPORT";
export const EARNING_CODE = 'EARNING_CODE';
export const EARNING_CODES = 'EARNING_CODES';
export const EDIT_CLIENT_DATA = 'EDIT_CLIENT_DATA';
export const EINS = 'EINS';
export const EXPORT_EARNING_CODE = "EXPORT_EARNING_CODE";
export const GET_ACCRUALS_REPORT = 'GET_ACCRUALS_REPORT';
export const GET_BG_TASKS = "GET_BG_TASKS";
export const GET_BILLING_SERVICES = 'GET_BILLING_SERVICES';
export const GET_COST_CENTERS = 'GET_COST_CENTERS';
export const GET_CERTIFIED_JOB_CC = "GET_CERTIFIED_JOB_CC";
export const GET_COUNTIES = 'GET_COUNTIES';
export const GET_EARNINGS_CODES = 'GET_EARNINGS_CODES';
export const GET_EXPIRATION_DATE = 'GET_EXPIRATION_DATE';
export const GET_EXPORT_EARNING_CODE = "GET_EXPORT_EARNING_CODE";
export const GET_ITEMS_ORDER = 'GET_PURCHASE_ORDER';
export const GET_LOCATION_BLANK = 'GET_LOCATION_BLANK';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const GET_OUTBOUND_PRE_DATA = 'GET_OUTBOUND_PRE_DATA';
export const GET_PAYROLL_DETAIL = "GET_PAYROLL_DETAIL";
export const GET_PAYROLL_EARNINGS_CODES = 'GET_PAYROLL_EARNINGS_CODES';
export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_ROLE_PERMISSIONS = "GET_ROLE_PERMISSIONS";
export const GET_SAVED_EARNINGS_CODES = 'GET_SAVED_EARNINGS_CODES';
export const GET_WAGE_LIST = 'GET_WAGE_LIST';
export const GET_WAGE_PARITY_REPORT = 'GET_WAGE_PARITY_REPORT';
export const GET_WAGE_RATE_LOCATIONS = 'GET_WAGE_RATE_LOCATIONS';
export const GET_WP_SETUP = 'GET_WP_SETUP';
export const GROUPING_ALLOW_DELETE = 'GROUPING_ALLOW_DELETE';
export const INVENTORY_ITEMS = 'INVENTORY_ITEMS';
export const LATE_PAYROLL = 'LATE_PAYROLL';
export const LATE_PAYROLL_DETAIL = 'LATE_PAYROLL_DETAIL';
export const LOCATION_LIST = 'LOCATION_LIST';
export const MIN_WAGE_LOCATION_DATA = 'MIN_WAGE_LOCATION_DATA';
export const NEW_HIRE = 'NEW_HIRE';
export const NJ_CERTIFIED_SETTINGS = 'NJ_CERTIFIED_SETTINGS';
export const NJ_CERTIFIED_PAYROLL = 'NJ_CERTIFIED_PAYROLL';
export const NO_PAYROLL_ACTIVITY = 'NO_PAYROLL_ACTIVE';
export const ORDER_ID = 'ORDER_ID';
export const PARENT_COST_CENTERS = 'PARENT_COST_CENTERS';
export const PATIENT_HOURS_REPORT = 'PATIENT_HOURS_REPORT';
export const PAY_PERIOD_PROFILES = 'PAY_PERIOD_PROFILES';
export const PURCHASE_ORDER = 'PURCHASE_ORDER';
export const PURCHASE_ORDERS = 'PURCHASE_ORDERS';
export const PHRS = 'PHRS';
export const PPD_ADMIN_SETTINGS = "PPD_ADMIN_SETTINGS";
export const PPD_ADMIN_SETTINGS_GET = 'PPD_ADMIN_SETTINGS_GET';
export const PPD_BUDGET = 'PPD_BUDGET';
export const PPD_BUDGET_SAVE = "PPD_BUDGET_SAVE";
export const PPD_CENSUS_DATA = 'PPD_CENSUS_DATA';
export const PPD_CENSUS_SAVE = 'PPD_CENSUS_SAVE';
export const PPD_CONTRACT_HOURS = 'PPD_CONTRACT_HOURS';
export const PPD_CONTRACT_HOURS_SAVE = 'PPD_CONTRACT_HOURS_SAVE';
export const PPD_OVERVIEW = "PPD_OVERVIEW";
export const REPORT_401K = 'REPORT_401K';
export const REPORT_ID = 'REPORT_ID';
export const ROLE_CONFIG = 'ROLE_CONFIG';
export const ROLE_LIST = "ROLE_LIST";
export const SALE_ORDER = 'SALE_ORDER';
export const SALE_ORDERS = 'SALE_ORDERS';
export const SAVE_PERMISSIONS = "SAVE_PERMISSIONS";
export const SCHEDULER_DAILY = 'SCHEDULER_DAILY';
export const SCHEDULER_MONTHLY = 'SCHEDULER_MONTHLY';
export const SET_ERROR = 'SET_ERROR';
export const SET_USER = 'SET_USER';
export const SET_USER_ERROR = 'SET_USER_ERROR';
export const SOH_SETTINGS = 'SOH_SETTINGS';
export const SOH_TOOL = 'SOH_TOOL';
export const SYNC_PH = 'SYNC_PH';
export const TAX_COLLECTIONS = 'TAX_COLLECTIONS';
export const TAX_PAYMENT = 'TAX_PAYMENT';
export const TEAM_SUPPORT_REGISTER = 'TEAM_SUPPORT_REGISTER';
export const TERMINATION_REASONS = 'TERMINATION_REASONS';
export const TOAST = 'TOAST';
export const TURNOVER_GROUPING = 'TURNOVER_GROUPING';
export const TURNOVER_GROUPINGS = "TURNOVER_GROUPINGS";
export const TURNOVER_RATE = 'TURNOVER_RATE';
export const TURNOVER_VIEW = 'TURNOVER_VIEW';
export const TURNOVER_VIEWS = 'TURNOVER_VIEWS';
export const UKG_INVOICE = 'UKG_INVOICE';
export const UKG_INVOICES = 'UKG_INVOICES';
export const UNRECORDED_ORDERS = 'UNRECORDED_ORDERS';
export const UPDATE_BILLING_SERVICES = 'UPDATE_BILLING_SERVICES';
export const UPDATE_PERVIOUS_DATE = 'UPDATE_PERVIOUS_DATE'
export const UPDATE_WAGE = 'UPDATE_WAGE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_ROLE_PERMISSION = 'USER_ROLE_PERMISSION';